import React, { useEffect, useState } from "react";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Divider from "../ui/Divider";
import { listen } from "../hooks/Listener";
import { KBD } from "../utils/Keybindings";
import { VALIDATE } from "../utils/Validators";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import { useGlobals } from "../hooks/Globals";

export default function Prompt(props) {

    const { controller = "", signal = {}, route = "", description = "", width = 234, inputProps = {}, callback = () => { }, permission = false, login = true } = props;
   
    const [init, setInit] = useState(true);
    const [id, setId] = useState(null);


    

    const actions = [
        { key: KBD.ESCAPE, action: () => { callback(false) } },
        { key: KBD.ENTER, action: () => { callback(id) } },
    ]

    useEffect(() => {
        const cleanup = listen(controller, route, actions, false, [KBD.ESCAPE, KBD.ENTER]);
        return cleanup;
    }, [actions, id])

      
    return (
        <>
            <div style={{ "width": (width) ? width + "px" : "auto" }}>
                <div className="shim" /><div className="shim" />
                <Space height={25} size={10}>
                    {(description && <Label>{description}</Label>)}
                    
                    <Input controlled={true} style={{"textAlign" : "center"}} onChange={(e) => setId(e)} autofocus autoselect placeholder=""  edit value={id} {...inputProps}  />
                </Space>
            </div>
            {/* <small><pre>{JSON.stringify(signal.value, null, 2)}</pre></small> */}
        </>
    )
}